module.exports = __webpack_public_path__ + "static/osohodi-766cb2e409ec7013ec3414631c5653ec.png";